import { Placeholder } from '@tiptap/extension-placeholder';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    placeholder: {
      updatePlaceholder: (placeholder: string) => ReturnType;
    };
  }
}

const PlaceholderExtended = Placeholder.extend({
  addOptions() {
    return {
      emptyEditorClass:
        'before:content-[attr(data-placeholder)] before:text-muted-foreground before:float-left before:h-0 before:pointer-events-none',
      emptyNodeClass: 'is-empty',
      placeholder: '',
      showOnlyWhenEditable: true,
      considerAnyAsEmpty: false,
      showOnlyCurrent: true,
      includeChildren: false,
    };
  },

  addCommands() {
    return {
      updatePlaceholder: (placeholder: string) => () => {
        this.options.placeholder = placeholder;

        // Force update
        this.editor.view.updateState(this.editor.state);
        return true;
      },
    };
  },
});

export default PlaceholderExtended;
